import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UserSessionObject } from '../common/entities/user-session-object';

@Injectable()//{ providedIn: 'root' }
export class AuthGuard implements CanActivate {

    constructor(private router: Router, public userSessionObject: UserSessionObject) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        //if (localStorage.getItem('UserAuthResponse')) {
        if (this.userSessionObject.UserAuthResponse != '') {

            // logged in so return true
            return true;
        }

        // not logged in so redirect to login page with the return url
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
    }
}